<template>
<RouterView />
    <RouterView name="onlyEditor" v-if="isForceLoad()" />
    <RouterView name="onlyHistory" v-else-if="isOnlyEditor()" />
    <RouterView name="isMobile" v-else-if="getBrowser().isMobile" />
    <RouterView name="isPc" v-else-if="!getBrowser().isMobile" />
</template>

<script lang="ts" setup="true">
import { RouterView } from 'vue-router';
import { onMounted } from 'vue';
import { getBrowser } from '@/utils/browser';

onMounted(() => {
    console.log('App mounted');
    console.timeEnd('time1111111111111App');
    console.time('time1111111111111Router');
});
const isForceLoad = () => {
  return new URLSearchParams(location.href).get('forceLoad') === 'true';
}
const isOnlyEditor = () => {
  return new URLSearchParams(location.href).get('history') === 'true';
}
</script>
